<template>
  <div>
    Prêts hypotécaires
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'PretsHypotecaires'
}
</script>
